var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartNutral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.95682 7.60813C1.00784 5.28335 2.49299 2.66797 4.79491 2.66797C6.08174 2.66797 7.12541 3.24917 7.99935 4.41156L8.10948 4.26929C8.96068 3.20174 9.97057 2.66797 11.2038 2.66797C13.5057 2.66797 14.9909 5.28335 14.0419 7.60813C13.6461 8.57758 12.7428 9.74824 11.332 11.1201C10.4882 11.9405 9.46185 12.81 8.77298 13.3765C8.32197 13.7475 7.67673 13.7475 7.22572 13.3765C6.53685 12.81 5.51046 11.9405 4.66674 11.1201C3.25586 9.74824 2.35255 8.57758 1.95682 7.60813Z",
    stroke: "#B9BBBE",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartNutral);
export default __webpack_public_path__ + "static/media/heart-nutral.ad0fd58e7af1e9d5692a3c44b0ea0a44.svg";
export { ForwardRef as ReactComponent };